import { forwardRef } from 'react';
import { cn } from '../utils/cn';
import styles from './AiFabButton.module.css';
import type { AiFabButtonProps } from './AiFabButton.types';

const AiFabButton = forwardRef<HTMLButtonElement, AiFabButtonProps>(
	({ hasUpdate = false, className, children, ...buttonProps }, ref) => {
		return (
			<button
				className={cn(styles.root, hasUpdate && styles.hasUpdate, className)}
				data-ai-fab-has-update={hasUpdate || undefined}
				data-testid="ai-fab-button"
				ref={ref}
				type="button"
				{...buttonProps}
			>
				{children}
				{hasUpdate && (
					<span
						aria-hidden="true"
						className={styles.badge}
						data-testid="ai-fab-button-badge"
					/>
				)}
			</button>
		);
	}
);

export { AiFabButton };
